import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { BILLING_PATH } from '../../../../config/paths';
import { DEFAULT_QUERY_GET_ALL } from '../../../../config/queries';
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';
import { tzNormalizeDate } from '../../../../utils/date';
import { DEFAULT_PAGE_SIZE } from '../../../../config/constants';
import { DATE_FORMAT } from '../../../../config/locale';
import { MANUAL_GRR_ENDPOINT_V2 } from '../../../../config/endpoints';

import { getBillingsV2, getBillReconciliation } from '../../../../actions';

import BillingSearchForm from './BillingSearchForm';
import BillingSearchResult from './BillingSearchResult';
import Content from '../../../layout/Content';

const toISODate = (date) => {
  if (!date) return null;

  if (/^\d{4}-\d{2}-\d{2}$/.test(date)) {
    return date;
  }

  const match = date.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);

  if (!match) {
    throw new Error(`Formato de fecha inválido: ${date}`);
  }

  const [, day, month, year] = match;

  return `${year}-${month}-${day}`;
};

export const Billings = ({
  dispatchGetBillingsV2,
  dispatchGetBillReconciliation,
  breadcrumbs,
}) => {
  const [query, setQuery] = useState('');

  const onSubmit = (formValues) => {
    const fromDate = tzNormalizeDate({
      date: formValues.fromDateString,
      format: DATE_FORMAT,
    });

    const toDate = tzNormalizeDate({
      date: formValues.toDateString,
      format: DATE_FORMAT,
    });

    const queryParts = [`issueDateBetween:${fromDate}_${toDate}`];

    if (formValues.agencyId) {
      queryParts.push(`agencyId:${formValues.agencyId.value}`);
    }

    const newFormValues = {
      ...DEFAULT_QUERY_GET_ALL,
      size: DEFAULT_PAGE_SIZE,
      query: queryParts,
    };

    setQuery(newFormValues.query);

    dispatchGetBillingsV2(newFormValues);

    dispatchGetBillReconciliation(toISODate(fromDate), toISODate(toDate));
  };

  const title = 'Sistema de emision electronica - Del Contribuyente';

  const subtitle = (
    <>
      Busca los datos de <strong>Facturación Electrónica</strong> para que
      puedas modificarlos y volver declararlos a SUNAT.
    </>
  );

  const content = (
    <>
      <BillingSearchForm
        onSubmit={onSubmit}
        initialValues={{
          fromDateString: tzNormalizeDate(),
          toDateString: tzNormalizeDate(),
        }}
        exportEndpoint={MANUAL_GRR_ENDPOINT_V2}
      />

      <BillingSearchResult queryProps={query} />
    </>
  );

  return (
    <Content
      breadcrumbs={breadcrumbs}
      title={title}
      subtitle={subtitle}
      content={content}
    />
  );
};

const mapStateToProps = ({ AccountingUnit }) => ({
  breadcrumbs: [
    ...AccountingUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Sistema de emision electronica - Del Contribuyente',
      href: BILLING_PATH,
    },
  ],
});

const mapDispatchToProps = {
  dispatchGetBillingsV2: getBillingsV2,
  dispatchGetBillReconciliation: getBillReconciliation,
};

Billings.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchGetBillingsV2: PropTypes.func.isRequired,
  dispatchGetBillReconciliation: PropTypes.func.isRequired,
};

Billings.defaultProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Billings);
